<template>
    <div class="row" style="justify-content: center">
        <div class="col-md-8 col-12 app-website-creation-container">
            <h1 class="kanit-bold fs-36 my-10">Create a new store</h1>
            <v-form ref="create_store_form" class="create-store-form my-5">
                <div class="kanit-bold fs-24 my-5">Store Information</div>
                <v-text-field v-model="params.name" @input="params.name && !ownDomain ? params.url = params.name.split(' ').join('-') : null" :maxlength="100" :rules="[validationRules.required]" label="Store name" outlined></v-text-field>
                <div class="row mb-3" style="align-items: center; transform: translateX(18px)">
                    <div class="mr-5" v-bind:class="ownDomain ? 'kanit-normal':'drop-blue'">Drop URL</div>
                    <v-switch color="blue" v-model="ownDomain"></v-switch>
                    <div class="ml-5" v-bind:class="ownDomain ? 'drop-blue':'kanit-normal'">I have my own domain</div>
                </div>
                <div style="position: relative">
                    <v-text-field v-if="params && params.url && params.url.length > 0 && !ownDomain" class="input-muted" style="position: absolute; width: 100%; max-width: 100%" :rules="[validationRules.url]" outlined v-model="websiteUrlSlug"></v-text-field>
                    <v-text-field class="text-field-transparent" outlined :label="$t('URL')" v-model="params.url" :rules="[validationRules.required]"></v-text-field>
                </div>
                <div class="kanit-bold fs-24 my-5">Owner Information</div>
                <v-text-field :maxlength="100" :rules="[validationRules.required]" v-model="params.address.street" label="Address" outlined></v-text-field>
                <v-text-field :maxlength="100" :rules="[validationRules.required]" v-model="params.address.city" label="City" outlined></v-text-field>
                <div style="display:flex; flex-wrap: wrap">
                    <v-text-field :maxlength="100" :rules="[validationRules.required]" class="col-md-6 col-12 left-tf" v-model="params.address.state" label="State" outlined></v-text-field>
                    <v-text-field :maxlength="20" :rules="[validationRules.required]" class="col-md-6 col-12 right-tf" v-model="params.address.postal" label="Postal code" outlined></v-text-field>
                </div>
                <v-select v-if="countriesList" style="width: 100%" class="temp-country-select" :rules="[validationRules.required]" v-model="params.address.country" label="Country" :items="this.countriesList" item-value="code" item-text="name" outlined></v-select>
                <secondary-button :activeButton="true" @clickBtn="samplesAddresHandler">
                    Change receiving product samples address
                </secondary-button>
                <div class="my-10" v-if="useSampleAddress">
                    <div class="fs-24 kanit-bold my-5">Samples address</div>
                    <v-text-field :maxlength="100" :rules="[validationRules.required]" v-model="params.sample_address.street" label="Address" outlined></v-text-field>
                    <v-text-field :maxlength="100" :rules="[validationRules.required]" v-model="params.sample_address.city" label="City" outlined></v-text-field>
                    <div style="display:flex; flex-wrap: wrap">
                        <v-text-field :maxlength="100" :rules="[validationRules.required]" class="col-md-6 col-12 left-tf" v-model="params.sample_address.state" label="State" outlined></v-text-field>
                        <v-text-field :maxlength="100" :rules="[validationRules.required]" class="col-md-6 col-12 right-tf" v-model="params.sample_address.postal" label="Postal code" outlined></v-text-field>
                    </div>
                    <v-select v-if="countriesList" style="width: 100%" class="temp-country-select" :rules="[validationRules.required]" v-model="params.sample_address.country" label="Country" :items="this.countriesList" item-value="code" item-text="name" outlined></v-select>
                </div>
                <div class="mb-4" style="color: #ff3333" v-if="errors">{{errors}}</div>
                <div style="align-items: center; display:flex">
                    <v-btn @click="createWebsite" class="temp-box-shadow fs-18 my-10 px-10" style="color:white" color="blue">Create a store</v-btn>
                    <v-progress-circular class="ml-5" v-if="loading" color="blue" indeterminate></v-progress-circular>
                </div>
            </v-form>
        </div>
    </div>
</template>
<script>
import {getCountries} from '../../api/app'
import {storeBread} from '../../api/bread'
export default {
    data(){
        return{
            params: {
                address:{
                    type: 'website_nexus',
                },
                sample_address: {
                    type: 'sample'
                },
                data: []
            },
            useSampleAddress: false,
            ownDomain: false,
            isCreationCompleted: false,
            countriesList: null,
            loading: false,
            errors: null,
        }
    },
    methods:{
        setActiveWebsite(website){
            this.$store.dispatch('websites/setActive', website);
            location.reload();
        },
        samplesAddresHandler(){
            this.useSampleAddress = !this.useSampleAddress
            if(this.useSampleAddress){
                this.params.sample_address = {...this.params.address};
                setTimeout(()=>{
                    window.scrollTo({top: 1000, behavior: 'smooth'});
                },10)
            }
        },
        createWebsite(){
            this.errors = null;
            if(this.$refs.create_store_form.validate()){
                this.loading = true;
                this.params.address.user_id = this.userId;
                this.params.sample_address.user_id = this.userId;
                this.params.user_id = this.userId;
                if(!this.useSampleAddress){
                    this.params.sample_address = {...this.params.address};
                }
                this.params.sample_address.type = 'sample';
                this.params.address.country = this.params.address.country.toUpperCase();
                this.params.sample_address.country = this.params.sample_address.country.toUpperCase();
                storeBread('Website', this.params).then(res=>{
                    this.$store.dispatch('websites/setActive', res);
                    this.$store.commit('app/ADD_MESSAGE', {text: this.$t('Website has been created successfully'), type:'success'});
                    this.loading = false;
                    this.$store.dispatch('websites/getWebsites');
                    setTimeout(()=>{
                        this.$router.push('/');
                    },800);
                }).catch(err=>{
                    this.errors = err.response.data.errors.url[0]
                    this.loading = false;
                });
            }
        }
    },
    created(){
        getCountries().then(res=>{
            this.countriesList = res;
        }).catch(()=>{})
    },
    computed:{
        websiteUrlSlug(){
            if(this.params && this.params.url && this.params.name.length > 0) return this.params.url+'.printdrop.com.au';
            return '.printdrop.com.au';
        },
        userId(){
            return this.$store.getters.user.id;
        },
    },
}
</script>
